<template>
  <el-upload
    ref="uploadForm"
    class="upload-demo"
    :limit="limit"
    :action="uploadUrl"
    :on-change="handleChange"
    :on-success="success"
    :on-preview="previewFun"
    :on-remove="removeFun"
    :headers="{Accept:'application/json, text/plain, */*'}"
    :with-credentials="true"
    :http-request="httpRequest"
    list-type="picture"
    :file-list="self_list">
<!--    <el-button size="mini" type="success">点击上传</el-button>-->
    <el-button size="small" type="primary">点击上传</el-button>
    <div slot="tip" class="el-upload__tip">只能上传jpg/png文件，且不超过500kb</div>
  </el-upload>
</template>

<script>
import axios from "axios";

export default {
  name: "UploadFilesSysc",
  props:{
    list:Array,
    hostUrl:String,
    uploadUrl:{
      type:String,
      default(){
        return ""
      }
    },
    limit:{
      type:Number,
      default(){
        return 1
      }
    },
  },
  model: {
    prop: "self_list", // 定义传递给v-model的那个变量，绑定到哪个属性值上               (默认值value)
    event: "success", // event:什么时候触发v-model行为(让父组件能获取到值)    (默认值input)
  },
  data(){
    return {
      self_list:[],
    }
  },
  mounted() {
    var that=this;
    if(this.list){
      this.self_list=this.list.map(ret=>{
        ret.url=that.$url(ret.image);
        return ret;
      })
    }

  },
  methods:{
    handleChange(file, fileList) {
      // console.log(file, fileList)
    },
    success(response, file, fileList){
      console.log(response, file, fileList)
      let list=[]
      var that=this;
      // let file_path=response.data.path.replace('\\','/').replace('//','/');
      console.log(fileList)
    },
    removeFun(file, fileList){
      this.self_list=fileList
      this.$emit("success",JSON.parse(JSON.stringify(this.self_list)))
    },
    previewFun(file){
      window.open(file.url);
    },
    httpRequest(item){
      var that=this;
      // 在这里进行一系列的校验
      let formData = new FormData();
      formData.append("file",item.file);
      axios.post(item.action,formData).then(res=>{
        if(res){
          item.url=res.data.data.path.replace('\\', '/').replace('//', '/');
          that.self_list.push({url:that.$url(item.url),image:item.url})
          that.$emit("success",JSON.parse(JSON.stringify(that.self_list)))
        }
      },err=>{
        // that.clearFlies()
      })
    },
    clearFlies() {
      this.$refs.uploadForm.clearFiles();
    },
    $url(url){
      return this.hostUrl+"/"+url;
    }
  },
  watch:{
    list:{
      handler(list){
        var that=this;
        if(list){
          this.self_list=list.map(ret=>{
            ret.url=that.$url(ret.image);
            return ret;
          })
        }
      },
      deep:true,
      immediate:true
    }
  }
}
</script>

<style lang="scss" scoped>
@import url(../common.scss);
.file-fm{
  justify-content: space-between;
  width: 300px;
  .file-fm-rt{
    width: 70px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Admin/App/Card/components/UploadFilesSysc.vue